import { css, cx } from "@emotion/css"
import { useQuery } from "react-query"
import { http } from "api/http"

import { DataEnvelop } from "@dashboards/helpers/api"
import { Card } from "@dashboards/components/Card"
//eslint-disable-next-line
import { customSGDFormat, percent } from "@dashboards/helpers/formatters"
import { getCurrentAmountOnly } from "@dashboards/helpers/annualChange"
import { Empty } from "@dashboards/components/Empty"
import { Skeleton } from "@dashboards/components/Skeleton"

import { Display } from "./Display"
import useFilters from "../../filters/hook"

const styles = {
  card: css`
    height: 96px;
    width: 100%;
  `,
  title: css`
    font-size: 13px;
    font-weight: 300;
  `,
}

export default function TotalBilled() {
  const { getSearchParams } = useFilters({ filters: ["startDate", "endDate"] })
  const { data, status } = useQuery(
    ["reporting/regional/total-billed", getSearchParams()],
    fetchData,
  )
  const isEmpty = status === "success" && data === undefined
  const amount = customSGDFormat(data?.current ?? 0)
  // const change = data?.change ? percent(data?.change) : "-"
  return (
    <Card className={cx(styles.card)}>
      <div className={styles.title}>Total Billed</div>
      {status === "loading" ? (
        <Skeleton />
      ) : isEmpty ? (
        <Empty />
      ) : (
        <Display amount={amount} />
      )}
    </Card>
  )
}

type ResponseItem = {
  // year: number
  billed: number
}

type Response = DataEnvelop<ResponseItem>
const fetchData = async (key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res: Response = await http(key, { searchParams, timeout: false }).json()
  const data = res?.data ?? []
  if (data.length === 0) return undefined
  return getCurrentAmountOnly(data, (x) => x.billed ?? 0)
}
